function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SettingsAppspaceTemplate = require('./main.template.js');
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SaitoModule = require('./../../../../lib/saito/ui/saito-module/saito-module');
var SaitoRecover = require('./../../../../lib/saito/ui/modals/saito-recovery/saito-recovery');
var jsonTree = require('json-tree-viewer');
var SettingsAppspace = /*#__PURE__*/function () {
  function SettingsAppspace(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, SettingsAppspace);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.privateKey = null;
    this.recover = new SaitoRecover(app, mod);
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(SettingsAppspace, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var settings_appspace, i, mod_settings_obj;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.app.wallet.getPrivateKey();
            case 1:
              this.privateKey = _context.v;
              this.seed_phrase = this.app.crypto.generateSeedFromPrivateKey(this.privateKey);
              this.overlay.show(SettingsAppspaceTemplate(this.app, this.mod, this));
              this.clearSettingsWarningBar();
              this.runBrowserNodeBuildCheck();

              /**
               *  No modules are implementing this, but it is an idea to let modules render a component
               *  into the Settings appspace overlay
               */
              settings_appspace = document.querySelector('.settings-appspace');
              if (settings_appspace) {
                for (i = 0; i < this.app.modules.mods.length; i++) {
                  if (this.app.modules.mods[i].respondTo('settings-appspace') != null) {
                    mod_settings_obj = this.app.modules.mods[i].respondTo('settings-appspace');
                    mod_settings_obj.render(this.app, this.mod);
                  }
                }
              }
              this.renderDebugTree();
              this.renderStorageInfo();
              this.renderCryptoGameSettings();
              _context.n = 2;
              return this.attachEvents();
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "clearSettingsWarningBar",
    value: function clearSettingsWarningBar() {
      var bar = document.getElementById('settings-appspace-warning-bar');
      if (!bar) {
        return;
      }
      bar.style.display = 'none';
      bar.innerHTML = '';
      bar.removeAttribute('aria-label');
    }
  }, {
    key: "showSettingsWarningBar",
    value: function showSettingsWarningBar(message) {
      var bar = document.getElementById('settings-appspace-warning-bar');
      if (!bar) {
        return;
      }
      bar.innerHTML = "<i class=\"fa-solid fa-triangle-exclamation\" aria-hidden=\"true\"></i><span class=\"settings-appspace-warning-bar-text\"></span>";
      var span = bar.querySelector('.settings-appspace-warning-bar-text');
      if (span) {
        span.textContent = message;
      }
      bar.style.display = 'flex';
      bar.setAttribute('aria-label', message);
    }
  }, {
    key: "selectPeerForBuildCheck",
    value: function selectPeerForBuildCheck(peers) {
      var connected = peers.filter(function (p) {
        return (p === null || p === void 0 ? void 0 : p.status) !== 'disconnected';
      });
      var fullNode = connected.find(function (p) {
        return p.synctype && p.synctype !== 'lite';
      });
      return fullNode || connected[0] || null;
    }
  }, {
    key: "updateBuildInfoValues",
    value: function updateBuildInfoValues(browserBuild, nodePeerBuildDisplay) {
      var browserEl = document.getElementById('settings-browser-build-value');
      var nodeEl = document.getElementById('settings-node-peer-build-value');
      if (browserEl) {
        browserEl.textContent = browserBuild;
      }
      if (nodeEl) {
        nodeEl.textContent = nodePeerBuildDisplay;
      }
    }
  }, {
    key: "runBrowserNodeBuildCheck",
    value: function runBrowserNodeBuildCheck() {
      var _this = this;
      if (!this.app.BROWSER) {
        return;
      }
      var browserBuild = String(this.app.build_number);
      this.updateBuildInfoValues(browserBuild, '—');
      _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var peers, peer, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return _this.app.network.getPeers();
            case 1:
              peers = _context2.v;
              peer = _this.selectPeerForBuildCheck(peers);
              if (peer) {
                _context2.n = 2;
                break;
              }
              _this.updateBuildInfoValues(browserBuild, '—');
              _this.clearSettingsWarningBar();
              return _context2.a(2);
            case 2:
              _this.app.network.sendRequestAsTransaction('settings server build', {}, function (res) {
                if (!res || res.err === 'no response') {
                  _this.updateBuildInfoValues(browserBuild, '—');
                  _this.clearSettingsWarningBar();
                  return;
                }
                var nodeBuild = res.build_number != null ? String(res.build_number) : '';
                if (!nodeBuild) {
                  _this.updateBuildInfoValues(browserBuild, '—');
                  _this.clearSettingsWarningBar();
                  return;
                }
                _this.updateBuildInfoValues(browserBuild, nodeBuild);
                if (browserBuild === nodeBuild) {
                  _this.clearSettingsWarningBar();
                  return;
                }
                _this.showSettingsWarningBar("Browser build ".concat(browserBuild, " does not match connected node build ").concat(nodeBuild, "."));
              }, peer.publicKey);
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.error('Settings build check:', _t);
              _this.updateBuildInfoValues(browserBuild, '—');
              _this.clearSettingsWarningBar();
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 3]]);
      }))();
    }

    //
    // Todo: Add a param to auto open one branch of the tree
    //
  }, {
    key: "renderDebugTree",
    value: function renderDebugTree() {
      var _this2 = this;
      //debug info
      var el = document.querySelector('.settings-appspace-debug-content');
      el.innerHTML = '';
      try {
        var optjson = JSON.parse(JSON.stringify(this.app.options, function (key, value) {
          return typeof value === 'bigint' ? value.toString() : value;
        } // return everything else unchanged
        ));
        var tree = jsonTree.create(optjson, el);
      } catch (err) {
        console.log('error creating jsonTree: ' + err);
      }
      if (document.getElementById('delete_marked')) {
        document.getElementById('delete_marked').onclick = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
            var updated, c;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  updated = false;
                  Array.from(document.querySelectorAll('.jsontree_node_marked')).forEach(function (node) {
                    updated = true;
                    var path = _this2.getJSONPath(node).replaceAll("\"]", '').split('["');
                    var obj = _this2.app.options;
                    while (path.length > 1) {
                      var key = path.shift();
                      if (key) {
                        obj = obj[key];
                      }
                    }
                    var final_key = path.shift();
                    console.log(obj, final_key);
                    if (Array.isArray(obj)) {
                      obj.splice(parseInt(final_key), 1);
                    } else {
                      delete obj[final_key];
                    }
                  });
                  _this2.renderDebugTree();
                  _context3.n = 1;
                  return sconfirm("Would you like to save your ".concat(updated ? 'updated ' : '', "options file?"));
                case 1:
                  c = _context3.v;
                  if (c) {
                    _this2.app.storage.saveOptions();
                  }
                case 2:
                  return _context3.a(2);
              }
            }, _callee3);
          }));
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }();
      }
    }
  }, {
    key: "getJSONPath",
    value: function getJSONPath(node) {
      if (node.classList.contains('jsontree_tree')) {
        return '';
      }
      var currentPath = '';
      //Find the label
      if (node.classList.contains('jsontree_node')) {
        if (node.children[0].classList.contains('jsontree_label-wrapper')) {
          //currentPath = node.querySelector(".jsontree_label").textContent;
          currentPath = '[' + node.querySelector('.jsontree_label').textContent + ']';
        }
      }
      return this.getJSONPath(node.parentElement) + currentPath;
    }
  }, {
    key: "renderCryptoGameSettings",
    value: function renderCryptoGameSettings() {
      var html = "";
      if (this.app.options.gameprefs != null) {
        var gameprefs = this.app.options.gameprefs;
        for (var key in gameprefs) {
          if (key.includes('inbound_trusted') || key.includes('outbound_trusted')) {
            var option_name = key.split('_');
            html += "<div class=\"settings-appspace-app\">\n\t\t\t              <div class=\"saito-switch\">\n\t\t\t                <input type=\"checkbox\" id=\"".concat(key, "\" class=\"crypto_transfers_checkbox\" name=\"").concat(key, "\" \n\t\t\t                ").concat(parseInt(gameprefs[key]) == 1 ? "checked=\"checked\"" : "", "\">\n\t\t\t              </div>\n\t\t\t              <div class=\"settings-appspace-crypto-transfer-name\">").concat(option_name[2], " ").concat(option_name[3], "</div>\n\t\t\t          </div>");
          }
        }
      }
      if (html) {
        document.querySelector('#settings-appspace-crypto-transfer').innerHTML = html;
      } else {
        // hide container from settings overlay
        document.querySelector('.settings-appspace-crypto-transfer-container').style.display = 'none';
      }
    }
  }, {
    key: "renderStorageInfo",
    value: function renderStorageInfo() {
      var _this3 = this;
      navigator.storage.estimate().then(function (estimate) {
        if (estimate !== null && estimate !== void 0 && estimate.usage && estimate !== null && estimate !== void 0 && estimate.quota) {
          var percentage = estimate.usage / estimate.quota * 100;
          document.querySelector('.settings-appspace-indexdb-info .quota').innerHTML = _this3.app.browser.formatNumberToLocale(estimate.quota);
          document.querySelector('.settings-appspace-indexdb-info .usage').innerHTML = _this3.app.browser.formatNumberToLocale(estimate.usage);
          document.querySelector('.settings-appspace-indexdb-info .percent').innerHTML = _this3.app.browser.formatNumberToLocale(percentage);
        } else {
          console.warn('Unexpected storage estimate: ', estimate);
        }
      })["catch"](function (err) {
        console.error(err);
      });
      function getLocalStorageSize() {
        var total = 0;
        for (var key in localStorage) {
          if (localStorage.hasOwnProperty(key)) {
            total += localStorage[key].length + key.length;
          }
        }
        return total;
      }
      function getLocalStorageUsagePercentage() {
        var totalSize = getLocalStorageSize();
        var maxSize = 5 * 1024 * 1024; // Estimated 5MB limit
        var percentageUsed = totalSize / maxSize * 100;
        return percentageUsed.toFixed(2); // Returns the percentage with 2 decimal points
      }
      document.querySelector('.settings-appspace-localstorage-info .quota').innerHTML = this.app.browser.formatNumberToLocale(5 * 1024 * 1024);
      document.querySelector('.settings-appspace-localstorage-info .usage').innerHTML = this.app.browser.formatNumberToLocale(getLocalStorageSize());
      document.querySelector('.settings-appspace-localstorage-info .percent').innerHTML = this.app.browser.formatNumberToLocale(getLocalStorageUsagePercentage());
      console.log("LocalStorage is ".concat(getLocalStorageUsagePercentage(), "% full."));
    }
  }, {
    key: "attachEvents",
    value: function () {
      var _attachEvents = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var _this4 = this;
        var app, mod, settings_appspace, i, mod_settings_obj, addAppBtn, addAppActivate;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              app = this.app;
              mod = this.mod;
              try {
                // Add this new event handler near the start of attachEvents
                document.getElementById('profile-default-fee-input').onchange = function (e) {
                  var _e$target$value$split;
                  var newDefaultFee = parseFloat(e.target.value);
                  var precision = ((_e$target$value$split = e.target.value.split('.')[1]) === null || _e$target$value$split === void 0 ? void 0 : _e$target$value$split.length) || 0;
                  if (newDefaultFee < 0 || newDefaultFee > 7000000000 || precision > 9) {
                    siteMessage('Entry invalid if it is negative, bigger than 7,000,000,000 or has more than nine units of precision.', 1000);
                    e.target.value = app.wallet.convertNolanToSaito(Number(app.options.wallet.default_fee));
                    return;
                  }

                  // Convert SAITO to nolan for storage
                  app.options.wallet.default_fee = app.wallet.convertSaitoToNolan(newDefaultFee.toString());
                  app.wallet.default_fee = BigInt(app.options.wallet.default_fee);
                  app.options.wallet = app.options.wallet || {};
                  app.storage.saveOptions();
                  siteMessage("Default fee updated to: ".concat(app.wallet.convertNolanToSaito(BigInt(app.options.wallet.default_fee)).toString(), " SAITO"), 1000);
                };
                settings_appspace = document.querySelector('.settings-appspace');
                if (settings_appspace) {
                  for (i = 0; i < app.modules.mods.length; i++) {
                    if (app.modules.mods[i].respondTo('settings-appspace') != null) {
                      mod_settings_obj = app.modules.mods[i].respondTo('settings-appspace');
                      mod_settings_obj.attachEvents(app, mod);
                    }
                  }
                }
                if (document.getElementById('register-identifier-btn')) {
                  document.getElementById('register-identifier-btn').onclick = function (e) {
                    app.connection.emit('register-username-or-login');
                  };
                }
                if (document.getElementById('trigger-appstore-btn')) {
                  document.getElementById('trigger-appstore-btn').onclick = function (e) {
                    var appstore_mod = app.modules.returnModule('AppStore');
                    if (appstore_mod) {
                      appstore_mod.openAppstoreOverlay(app, appstore_mod);
                    }
                  };
                }

                //
                // install module (button)
                //
                Array.from(document.getElementsByClassName('modules_mods_checkbox')).forEach(function (ckbx) {
                  ckbx.onclick = /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
                      var thisid, currentTarget, sc, _sc;
                      return _regenerator().w(function (_context4) {
                        while (1) switch (_context4.n) {
                          case 0:
                            e.stopPropagation();
                            thisid = parseInt(e.currentTarget.id);
                            currentTarget = e.currentTarget;
                            if (!(currentTarget.checked == true)) {
                              _context4.n = 2;
                              break;
                            }
                            _context4.n = 1;
                            return sconfirm('Reactivate this module? (Will take effect on refresh)');
                          case 1:
                            sc = _context4.v;
                            if (sc) {
                              app.options.modules[thisid].active = 1;
                              app.storage.saveOptions();
                            } else {
                              currentTarget.checked = false;
                            }
                            _context4.n = 4;
                            break;
                          case 2:
                            _context4.n = 3;
                            return sconfirm('Remove this module? (Will take effect on refresh)');
                          case 3:
                            _sc = _context4.v;
                            if (_sc) {
                              app.options.modules[thisid].active = 0;
                              app.storage.saveOptions();
                            } else {
                              currentTarget.checked = true;
                            }
                          case 4:
                            return _context4.a(2);
                        }
                      }, _callee4);
                    }));
                    return function (_x2) {
                      return _ref3.apply(this, arguments);
                    };
                  }();
                });

                //
                // in-game crypto transfers
                //
                Array.from(document.getElementsByClassName('crypto_transfers_checkbox')).forEach(function (ckbx) {
                  ckbx.onclick = /*#__PURE__*/function () {
                    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(e) {
                      var thisid, currentTarget, sc;
                      return _regenerator().w(function (_context5) {
                        while (1) switch (_context5.n) {
                          case 0:
                            e.stopPropagation();
                            thisid = e.currentTarget.id;
                            currentTarget = e.currentTarget;
                            console.log('Checbox id: //////', thisid);
                            if (!(currentTarget.checked == false)) {
                              _context5.n = 2;
                              break;
                            }
                            _context5.n = 1;
                            return sconfirm('Turning off this setting will make gameplay slower, are you sure?');
                          case 1:
                            sc = _context5.v;
                            if (sc) {
                              app.options.gameprefs[thisid] = 0;
                            } else {
                              currentTarget.checked = true;
                            }
                            _context5.n = 3;
                            break;
                          case 2:
                            app.options.gameprefs[thisid] = 1;
                          case 3:
                            _context5.n = 4;
                            return app.wallet.saveWallet();
                          case 4:
                            return _context5.a(2);
                        }
                      }, _callee5);
                    }));
                    return function (_x3) {
                      return _ref4.apply(this, arguments);
                    };
                  }();
                });
                Array.from(document.getElementsByClassName('settings-appspace-app')).forEach(function (modlink) {
                  modlink.onclick = /*#__PURE__*/function () {
                    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(e) {
                      var modname, _mod, mod_overlay;
                      return _regenerator().w(function (_context6) {
                        while (1) switch (_context6.n) {
                          case 0:
                            modname = e.currentTarget.dataset.id;
                            if (!modname) {
                              _context6.n = 2;
                              break;
                            }
                            _mod = _this4.app.modules.returnModule(modname);
                            if (_mod) {
                              _context6.n = 1;
                              break;
                            }
                            console.error('Module not found! ', modname);
                            return _context6.a(2);
                          case 1:
                            mod_overlay = new SaitoModule(_this4.app, _mod, function () {
                              _this4.renderDebugTree();
                            });
                            mod_overlay.render();
                          case 2:
                            return _context6.a(2);
                        }
                      }, _callee6);
                    }));
                    return function (_x4) {
                      return _ref5.apply(this, arguments);
                    };
                  }();
                });
                if (document.getElementById('backup-account-btn')) {
                  document.getElementById('backup-account-btn').onclick = function (e) {
                    app.wallet.backupWallet();
                  };
                }
                if (document.getElementById('restore-account-btn')) {
                  document.getElementById('restore-account-btn').onclick = /*#__PURE__*/function () {
                    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(e) {
                      return _regenerator().w(function (_context7) {
                        while (1) switch (_context7.n) {
                          case 0:
                            _this4.recover.loadFile();
                          case 1:
                            return _context7.a(2);
                        }
                      }, _callee7);
                    }));
                    return function (_x5) {
                      return _ref6.apply(this, arguments);
                    };
                  }();
                }
                if (document.getElementById('show-phrase')) {
                  document.getElementById('show-phrase').onclick = /*#__PURE__*/function () {
                    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(e) {
                      var _app$options;
                      var egldMnemonic, confirmBackup;
                      return _regenerator().w(function (_context8) {
                        while (1) switch (_context8.n) {
                          case 0:
                            egldMnemonic = (app === null || app === void 0 || (_app$options = app.options) === null || _app$options === void 0 || (_app$options = _app$options.crypto) === null || _app$options === void 0 || (_app$options = _app$options.EGLD) === null || _app$options === void 0 ? void 0 : _app$options.mnemonic_text) || '';
                            if (!(egldMnemonic && egldMnemonic !== _this4.seed_phrase)) {
                              _context8.n = 1;
                              break;
                            }
                            _context8.n = 1;
                            return sconfirm('Warning: Your EGLD wallet is using a different seed phrase. ' + 'Backing up only the Saito seed does NOT back up your EGLD keys. ');
                          case 1:
                            _context8.n = 2;
                            return sconfirm("<h4>Copy to clip board?</h4> <br> <span class=\"monospace\">".concat(_this4.seed_phrase, "</div>"));
                          case 2:
                            confirmBackup = _context8.v;
                            if (confirmBackup) {
                              navigator.clipboard.writeText(_this4.seed_phrase);
                            }
                          case 3:
                            return _context8.a(2);
                        }
                      }, _callee8);
                    }));
                    return function (_x6) {
                      return _ref7.apply(this, arguments);
                    };
                  }();
                }
                document.getElementById('nuke-account-btn').onclick = /*#__PURE__*/function () {
                  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(e) {
                    var confirmation;
                    return _regenerator().w(function (_context9) {
                      while (1) switch (_context9.n) {
                        case 0:
                          _context9.n = 1;
                          return app.wallet.onUpgrade('nuke');
                        case 1:
                          confirmation = _context9.v;
                          if (confirmation) {
                            reloadWindow(150);
                          }
                        case 2:
                          return _context9.a(2);
                      }
                    }, _callee9);
                  }));
                  return function (_x7) {
                    return _ref8.apply(this, arguments);
                  };
                }();
                if (document.getElementById('clear-storage-btn')) {
                  document.getElementById('clear-storage-btn').onclick = /*#__PURE__*/function () {
                    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(e) {
                      var confirmation, archive;
                      return _regenerator().w(function (_context0) {
                        while (1) switch (_context0.n) {
                          case 0:
                            _context0.n = 1;
                            return sconfirm("This will clear your browser's DB, proceed cautiously");
                          case 1:
                            confirmation = _context0.v;
                            if (!confirmation) {
                              _context0.n = 5;
                              break;
                            }
                            siteMessage('Clearing local "forage"...');
                            // Centrally Manage localForage
                            _context0.n = 2;
                            return _this4.app.storage.clearLocalForage();
                          case 2:
                            siteMessage('Clearing local installed apps...');
                            // And purge dyn mods
                            _context0.n = 3;
                            return _this4.app.storage.removeAllLocalApplications();
                          case 3:
                            archive = _this4.app.modules.returnModule('Archive');
                            if (!archive) {
                              _context0.n = 4;
                              break;
                            }
                            siteMessage('Clearing archive...');
                            _context0.n = 4;
                            return archive.onUpgrade('nuke');
                          case 4:
                            siteMessage('Clearing cookies....');
                            localStorage.clear();
                            _this4.app.storage.saveOptions();
                            siteMessage('rebooting...');
                            if (_this4.app.browser.browser_active == 1) {
                              reloadWindow(300);
                            }
                          case 5:
                            return _context0.a(2);
                        }
                      }, _callee0);
                    }));
                    return function (_x8) {
                      return _ref9.apply(this, arguments);
                    };
                  }();
                }
                Array.from(document.querySelectorAll('.settings-appspace .pubkey-grid')).forEach(function (key) {
                  key.onclick = function (e) {
                    navigator.clipboard.writeText(e.currentTarget.dataset.id);
                    var icon_element = e.currentTarget.querySelector('.pubkey-grid i');
                    icon_element.classList.toggle('fa-copy');
                    icon_element.classList.toggle('fa-check');
                    setTimeout(function () {
                      icon_element.classList.toggle('fa-copy');
                      icon_element.classList.toggle('fa-check');
                    }, 1500);
                  };
                });
                document.getElementById('copy-private-key').onclick = function (e) {
                  navigator.clipboard.writeText(_this4.privateKey);
                  var icon_element = document.querySelector('#copy-private-key i');
                  if (icon_element) {
                    icon_element.classList.toggle('fa-copy');
                    icon_element.classList.toggle('fa-check');
                    setTimeout(function () {
                      icon_element.classList.toggle('fa-copy');
                      icon_element.classList.toggle('fa-check');
                    }, 1500);
                  }
                };
                document.getElementById('restore-privatekey-btn').onclick = /*#__PURE__*/function () {
                  var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(e) {
                    return _regenerator().w(function (_context1) {
                      while (1) switch (_context1.n) {
                        case 0:
                          _this4.recover.render();
                        case 1:
                          return _context1.a(2);
                      }
                    }, _callee1);
                  }));
                  return function (_x9) {
                    return _ref0.apply(this, arguments);
                  };
                }();
              } catch (err) {
                console.log('Error in Settings Appspace: ', err);
              }
              if (document.querySelector('#settings-add-app')) {
                addAppBtn = document.querySelector('#settings-add-app');
                addAppActivate = function addAppActivate(e) {
                  e.preventDefault();
                  e.stopPropagation();
                  app.connection.emit('saito-app-app-render-request');
                };
                addAppBtn.onclick = addAppActivate;
                addAppBtn.onkeydown = function (e) {
                  if (e.key === 'Enter' || e.key === ' ') {
                    addAppActivate(e);
                  }
                };
              }
            case 1:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function attachEvents() {
        return _attachEvents.apply(this, arguments);
      }
      return attachEvents;
    }()
  }]);
}();
module.exports = SettingsAppspace;